module.exports = __webpack_public_path__ + "static/media/p7.de36d3e3.jpg";